import React, {useEffect, useState, useRef} from 'react';
import {makeStyles, withStyles} from '@mui/styles';
import {Button, Container, Grid, Icon, MenuItem, TextField} from "@mui/material";
import Typography from "@mui/material/Typography";
import clsx from "clsx";
import ReCAPTCHA from 'react-google-recaptcha';

const NautilusTextInput = withStyles({
    root: {
        backgroundColor: 'white',
        '& .MuiInputBase-input': {
            fontSize: '1.2rem',
            height: '2em',
        },
        '& .MuiFormLabel-root': {
            fontSize: '1.2rem',
        },
        '& label.Mui-focused': {
            color: '#1ebce7',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#1ebce7',
        },
        '& .MuiOutlinedInput-root': {
            borderRadius: 2,
            // '& fieldset': {
            //     borderColor: 'red',
            // },
            '&:hover fieldset': {
                borderColor: '#1ebce7',
            },
            '&.Mui-focused': {
                '& fieldset': {
                    borderColor: '#1ebce7',
                    '& legend': {
                        padding: '3px'
                    }
                }
            },
            '&.Mui-focused .MuiSelect-select fieldset': {
                '& legend': {
                    padding: '0'
                }
            },
        },
    },
})(TextField);

const useStyles = makeStyles((theme) => ({
    button: {
        lineHeight: 2.5,
        fontSize: '1.4rem',
        backgroundColor: '#00b7f0',
        borderColor: '#00b7f0',
    },
    root: {
        '& .MuiPaper-elevation1': {
            boxShadow: 'none'
        }
    }
}));

const WaitListForm = ({waitData, setWaitData, submitWaitList}) => {
    const recaptchaRef = useRef();

    const classes = useStyles();

    const handleForm = (event) => {
        setWaitData(event);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const token = await recaptchaRef.current.executeAsync();
        submitWaitList();
    };



    return (
        <Container maxWidth={'lg'} id="WaitListForm" style={{minWidth: 350, paddingLeft: 0, paddingRight: 0}}
                   className={classes.root}>
            <form className={'WaitListForm'} noValidate onSubmit={handleSubmit}>
                <Grid container direction="row" justify="center" alignItems="center" style={{paddingBottom: 30}}>
                    <Grid item xs={12}>
                        <Typography variant="h3" component="h3">
                            Trip Wait List <br/>
                        </Typography>
                        <Typography variant="body1" component="p" style={{padding: 10, fontSize: '16px'}}>
                            Let us put your name on our Wait List. <br/>
                            Please provide some details so we can get in touch with you if any spots on this trip become
                            available.
                        </Typography>
                    </Grid>
                    <Grid item xs={6} md={4} style={{padding: 5}}>
                        <NautilusTextInput fullWidth name="firstname" value={waitData['firstname']}
                                           onChange={handleForm} label="First Name" variant="outlined"/>
                    </Grid>
                    <Grid item xs={6} md={4} style={{padding: 5}}>
                        <NautilusTextInput fullWidth name="lastname" value={waitData['lastname']} onChange={handleForm}
                                           label="Last Name" variant="outlined"/>
                    </Grid>
                    <Grid item xs={6} md={4} style={{padding: 5,}}>
                        <NautilusTextInput fullWidth name="email" value={waitData['email']} onChange={handleForm}
                                           label="Email Address" variant="outlined"/>
                    </Grid>
                    <Grid item xs={6} md={4} style={{padding: 5}}>
                        <NautilusTextInput fullWidth name="phone" value={waitData['phone']} onChange={handleForm}
                                           label="Phone" variant="outlined"/>
                    </Grid>
                    <Grid item xs={6} md={4} style={{padding: 5}}>
                        <NautilusTextInput fullWidth name="guests" value={waitData['guests']} onChange={handleForm}
                                           label="Number of Guests" variant="outlined"/>
                    </Grid>
                    <Grid item xs={12} md={4} style={{padding: 5}}>
                        <NautilusTextInput fullWidth name="interest" value={waitData['interest']} variant="outlined"
                                           select label="I am interested in"
                                           onChange={handleForm}>
                            <MenuItem value={''}>
                                I am interested in
                            </MenuItem>
                            <MenuItem value={"This Trip Only"}>This Trip Only</MenuItem>
                            <MenuItem value={"Any Trip This Month"}>Any Trip This Month</MenuItem>
                            <MenuItem value={"Any Socorro Trip"}>Any Socorro Trip</MenuItem>
                            <MenuItem value={"Any Sea of Cortez Trip"}>Any Sea of Cortez Trip</MenuItem>

                        </NautilusTextInput>
                    </Grid>
                    <Grid item xs={12} style={{padding: 5}}>
                        <NautilusTextInput fullWidth name="comments" value={waitData['comments']}
                                           placeholder={'Comments, Notes, Requests'} onChange={handleForm} multiline
                                           rows={4} label="Comments, Notes, Requests" variant="outlined"/>
                    </Grid>
                    <Grid item xs={12} style={{padding: 5}}>
                        <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey={window.recaptchaKey}
                            size="invisible"
                        />
                    </Grid>
                    <Grid item xs={12} style={{padding: 5}}>
                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            fullWidth
                            className={clsx({[classes.button]: true, 'payButton': true})}
                            startIcon={<Icon>send</Icon>}
                        >
                            ADD ME TO WAIT LIST
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </Container>
    );
};

export default WaitListForm;